export default __webpack_public_path__ + "static/media/user-type-player-regular.f66a16e1.svg";